(function () {
    'use strict';

    angular
        .module('app')
        .controller('SubjectsAddController', SubjectsAddController);

    SubjectsAddController.$inject = ['debug', '$stateParams', 'API', '$state'];

    function SubjectsAddController(debug, $stateParams, API, $state) {
        var vm = this;
        vm.isAdding = false;
        vm.add = add;
        vm.subject = {
            internal_name: '',
            age_from: 5,
            age_to: 10,
            translations: {},
        };

        function add() {
            if (!vm.isAdding) {
                vm.isAdding = true;

                var newSubject = new API.Subject(vm.subject);

                var promise = newSubject.$save();

                promise.then(function (response) {
                    $state.go('subjects.edit', { id: response.id });
                }, function (response) {
                    debug.log(response);
                })
                .finally(function() {
                    vm.isAdding = false;
                });
            }
        }
    }
})();